import settings from "../../../constants/settings";
import useSWRFetcher, { SWRFetchError } from "../commonly-stored/fetcher";
import useSWR from "swr";
import { FLASHPCB_BIN_BARCODE_REGEX } from "../../../components/internal/parts/InventoryBinForm";
import { useCallback, useEffect, useState } from "react";
import { InventoryBin } from "../../../components/internal/parts/Bins/inventoryBinTypes";

export default function useInventoryBin(binBarcodeOrId: string | null) {
  const fetcher = useSWRFetcher<InventoryBin>();
  const [cannotFindBin, setCannotFindBin] = useState(false);

  const shouldFetch =
    binBarcodeOrId !== null &&
    (FLASHPCB_BIN_BARCODE_REGEX.test(binBarcodeOrId) ||
      (!binBarcodeOrId.startsWith("FPCB-B") && binBarcodeOrId.length === 24));

  const {
    data: inventoryBin,
    mutate,
    error,
    isLoading,
  } = useSWR<InventoryBin, SWRFetchError>(
    shouldFetch ? `${settings.api_url}/inventory/bins/${binBarcodeOrId}` : null,
    fetcher,
    {
      shouldRetryOnError: (error: SWRFetchError) => {
        return error.status != 404;
      },
    },
  );

  useEffect(() => {
    setCannotFindBin(error?.status === 404);
  }, [error?.status]);

  const refreshInventoryBin = useCallback(() => {
    void mutate();
  }, [mutate]);

  return {
    inventoryBin: inventoryBin,
    refreshInventoryBin,
    errored: error !== undefined,
    cannotFindBin,
    isLoading: shouldFetch && isLoading,
  };
}
